import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// GET /catalog/products/:productId/recent-quotes?excludeQuotationId= — the
// proforma-rules skill's "last three quoted prices for that product, with
// date and customer, as read-only reference." Only fires once a productId
// is known (matched or manually selected) — see routes/catalogRoutes.js.
export function useRecentQuotes(productId, excludeQuotationId) {
  return useQuery({
    queryKey: ['catalog', 'recent-quotes', productId ?? null, excludeQuotationId ?? null],
    queryFn: () =>
      apiClient.get(`/catalog/products/${productId}/recent-quotes`, { excludeQuotationId }),
    select: (data) => data.quotes,
    enabled: Boolean(productId),
  });
}

export default useRecentQuotes;
